<template>
  <div class="wrapper">
    <row-parallax-header></row-parallax-header>
    <!--<row-banner-header></row-banner-header>-->
    <row-info-section
      :_text-title="mTextOurBusiness.title"
      :_text-sub-title="mTextOurBusiness.subtitle"
      :_text-description="mTextOurBusiness.desc"
      :_image-url="require('../assets/bkgBannerDesk2Resize.jpg')">
    </row-info-section>
    <row-info-section
      :_reverse="true"
      :_text-background="'#fcfcfc'"
      :_light-mode="true"
      :_text-title="mTextInnovation.title"
      :_text-sub-title="mTextInnovation.subtitle"
      :_text-description="mTextInnovation.desc"
      :_image-url="require('../assets/bkgBannerCityResize.jpg')">
    </row-info-section>
    <!--<row-quote></row-quote>-->
    <row-contact-us></row-contact-us>
    <row-footer></row-footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      mTextOurBusiness: {
        title: 'Our Business',
        subtitle: 'How We Got Here',
        desc: [
          'Starting with the customer in mind, ' +
          'our engineers and programmers make it simple to get your sensors and devices online. ' +
          'BetterSense connects your data to you - the way you want - SMS/email/App/Online/API. ' +
          'Instead of logging into multiple proprietary dashboards, ' +
          'your data from multiple networks/platforms is standard, ' +
          'secured and in one place. Simple.'
        ]
      },
      mTextInnovation: {
        title: 'Our Innovative Technology',
        subtitle: 'Advanced Solutions',
        desc: [
          'BetterSense have integrated over 150 device types to allow one view of your data. Our industry leading platform can apply logic or standardise incoming data, minimising your own IT changes when introducing new sensors.\n' +
          'Your cool-store temp out of range at 2am and someone should know?\n' +
          'Can\'t find your expensive test gear?\n' +
          'Like to know where all your concrete trucks are right now?\n' +
          'Have all the roller doors and yard gates been closed each night - at all your premises?\n' +
          '\n' +
          'Now is good'
        ]
      }
    }
  },
  components: {
    RowParallaxHeader: require('../components/RowParallaxHeader.vue').default,
    RowBannerHeader: require('../components/RowBannerHeader.vue').default,
    RowInfoSection: require('../components/RowInfoSection.vue').default,
    RowQuote: require('../components/RowQuote.vue').default,
    RowContactUs: require('../components/RowContactUs.vue').default,
    RowFooter: require('../components/RowFooter.vue').default
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0px;
  }
  a {
    color: #42b983;
  }
  .wrapper {
    /* The height needs to be set to a fixed value for the effect to work.
   * 100vh is the full height of the viewport. */
    height: 100vh;
    /* The scaling of the images would add a horizontal scrollbar, so disable x overflow. */
    overflow-x: hidden;
    /* Enable scrolling on the page. */
    overflow-y: auto;
    /* Set the perspective to 2px. This is essentailly the simulated distance from the viewport to transformed objects.*/
    perspective: 2px;
  }
  @media screen and (max-width: 768px) {
    .wrapper {
      perspective: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue